$mol_view_tree2_to_js_test_ex_right_hierarchy_foo $mol_object
	Indexed*xxx $mol_view_tree2_to_js_test_ex_right_hierarchy_bar
		title? => indexed_title*?
		id <= indexed_id* 0
	prj $mol_view_tree2_to_js_test_ex_right_hierarchy_bar
		domain* => prj_domain*
			user => prj_user*
				id => prj_user_id*
